// eslint-disable-next-line filenames/match-regex
import {TableIcon} from '@primer/octicons-react'
import {Link, Octicon} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import type {RemovedFromProjectV2Event$key} from './__generated__/RemovedFromProjectV2Event.graphql'
import {TimelineRow} from './row/TimelineRow'

type RemovedFromProjectV2EventProps = {
  queryRef: RemovedFromProjectV2Event$key
  issueUrl: string
}

export function RemovedFromProjectV2Event({queryRef, issueUrl}: RemovedFromProjectV2EventProps): JSX.Element {
  const {actor, createdAt, project} = useFragment(
    graphql`
      fragment RemovedFromProjectV2Event on RemovedFromProjectV2Event {
        createdAt
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        project {
          title
          url
        }
      }
    `,
    queryRef,
  )

  if (!project) {
    return <></>
  }

  // Once we have support for the project IDs being exposed in GQL we can shift to using the
  // `issueEventExternalUrl` function here for our deep linked timestamp.
  return (
    <TimelineRow highlighted={false} actor={actor} createdAt={createdAt} actorAvatar={actor} deepLinkUrl={issueUrl}>
      <>
        {`${LABELS.timeline.removedThisFrom} `}
        <Octicon icon={TableIcon} />{' '}
        <Link href={project.url} sx={{color: 'fg.default', mr: 1}}>
          {project.title}
        </Link>
      </>
    </TimelineRow>
  )
}

try{ RemovedFromProjectV2Event.displayName ||= 'RemovedFromProjectV2Event' } catch {}